<script setup>
import {reactive,onMounted,computed} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const data = reactive({
  search: null,
  hTotal: 0,
  hRTotal: 0,
  dTotal: 0,
  aTotal: 0,

  dataLoading: true,
  headers: [
    { title: 'Person', key: 'name' },
    { title: 'Disbursements', key: 'grossFormatted' },
    { title: 'Holdbacks', key: 'holdbacksFormatted' },
    { title: 'Released Holdbacks', key: 'releasedHoldbacksFormatted' },
    { title: 'Adjustments', key: 'adjustmentsFormatted' },
    { title: 'Net', key: 'net' },

  ],
  items: [],
})

const csvData = computed(()=>{
  // CSV File
  return data.items.map((item) => ({
    ID: item.personid,
    Person: item.name,
    Disbursements: item.grossFormatted,
    Holdbacks: item.holdbacksFormatted,
    ReleasedHoldbacks: item.releasedHoldbacksFormatted,
    Adjustments: item.adjustmentsFormatted,
    Net: item.net
  }))
});

const csvExport = (arrData) => {
  // CSV File
  let csvContent = 'data:text/csv;charset=utf-8,'
  for(let x in arrData){
    arrData[x].Person = arrData[x].Person.replace(',', '')
  }
  csvContent += '"' + [
    Object.keys(arrData[0]).join('","'),
    ...arrData.map((item) => Object.values(item).join('","')),
  ]
      .join('"\n"')
      .replace(/(^\[)|(\]$)/gm, '')

  const data = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', 'export.csv')
  link.click()
}

onMounted(()=>{
  ApiWrapper.get('pay-period', 'details','payPeriodId=' + props.contextIdA)
      .then((response) => {
          if(response.rows){
            for(let x in response.rows){
              let item = response.rows[x];
              response.rows[x].net = Math.round((item.grossFormatted - item.adjustmentsFormatted - item.holdbacksFormatted + item.releasedHoldbacksFormatted) * 100) / 100
              data.hTotal += item.holdbacksFormatted * 1
              data.hRTotal += item.releasedHoldbacksFormatted * 1
              data.dTotal += item.grossFormatted * 1
              data.aTotal += item.adjustmentsFormatted * 1
            }
            data.items = response.rows;
          }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
      })
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Pay Period Details</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-icon @click="csvExport(csvData)" v-if="data.items.length"> mdi-file-download </v-icon>
      </v-toolbar>

      <v-row>
        <v-col cols="4">
          <v-text-field v-model="data.search" append-icon="mdi-magnify" label="Search" single-line hide-details
                        class="ml-4"></v-text-field>
        </v-col>
        <v-col cols="8">
          <span class="pr-2">Disbursements: {{Math.round(data.dTotal * 100) / 100}}</span>
          <span class="pr-2">Holdbacks: {{Math.round(data.hTotal * 100) / 100}}</span>
          <span class="pr-2">Released Holdbacks: {{Math.round(data.hRTotal * 100) / 100}}</span>
          <span class="pr-2">Adjustments: {{Math.round(data.aTotal * 100) / 100}}</span>
        </v-col>
      </v-row>
      <v-data-table :items="data.items" :headers="data.headers" :search="data.search" :loading="data.dataLoading"
                    loading-text="Loading... Please wait">
        <!-- <template v-slot:item.gross="{ item }">
          <span>{{ item.grossFormatted * 1}}</span>
        </template>
        <template v-slot:item.holdbacks="{ item }">
          <span>{{ item.holdbacksFormatted * 1}}</span>
        </template>
        <template v-slot:item.adjustments="{ item }">
          <span>{{ item.adjustmentsFormatted * 1 }}</span>
        </template> -->
        <template v-slot:[`item.name`]="{ item }">
          <RouterLink :to="`/payperiod/${item.ppid}/person/${item.personid}`">
            {{ item.name }}
          </RouterLink>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>